import apiUrl from '../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import Loader from './../shared/loader'
import download from 'downloadjs'

import {BasicSelect} from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

import Pagination from './../shared/pagination'
// import Vue from "vue";
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);


export default {
  name: 'rejectreason',
  components: {
    Pagination,
    DatePicker,
    download,
    Loader,
    BasicSelect
  },
  data: function() {
    return {
			WarehouseErr: '',
			ClientErr: '',
			totalPage: 0,
			currentPage: 1,
			pageLimit:10,
      totalrows:0,
      formattedDate: '',
			addRejectReasonmodal: false,
			detailRejectReasonmodal: false,
			listRejectReasonData: [],
			listRejectReasonDetailsData: [],
			listforviewRejectReasonData: [],
			listWarehouseAddReason: [],
			clientid: '',
			resultCount: 0,
			// pageno: 0,
			// totalPage: 0,
			Reasonaction: '',
			rejectreason: '',
			rejectreasonmasterid: '',
			status: '',
			Statusaction: '',
			addmodalShow: false,
			rejectID: '',
			loginUserEmail: '',
			showSelectClient: '',
			showSelectWarehouse: '',
			listWarehouseData: '',
			resultCountDetail: 0,
			warehouse: '',
			client: '',
			listclientData: [],
			addclientid: '',
			listWarehouseData: [],
      listReportDataforxls:[],
			addWarehouseid: '',
			WarehouseErr: '',
			isLoading: false,
      isLoadingforxls: false,
      download: true,
      show:'',
      csvFieldsForXls:{},


		}
  },
  beforeCreate: function() {
    this.isLoading = true;
  },

  created: function() {},
  filters: {
    moment: function(date) {
      if (!date) return '';
      return moment(date).format('DD-MM-YY HH:mm:ss');
    }
  },
  // when a page loads,mounted() will be call
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    var today = new Date();
    this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
    this.reportname = "rejectreasonreport"
    this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
    this.user_type = userdetail.utype;
    this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
    switch (this.user_type) {
      case 'system_user':
        this.showSelectClient = true;
        this.showSelectWarehouse = true;
        this.loginUserEmail = userdetail.email;
        // this.getClientList();
        // this.getWarehouseList();
        break;

      case 'client_user':
        this.loginUserEmail = userdetail.email;
        this.clientid = userdetail.clientid;
        this.client = this.clientid;
        // this.getWarehouseList();
        this.showSelectWarehouse = true;
        break;

      case 'warehouse_user':
        this.loginUserEmail = userdetail.email;
        this.warehouseid = userdetail.warehouseid;
        console.log(this.warehouseid,"---------------__>")
        this.warehousename = userdetail.fullname;
        this.showSelectClient = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
        break;

      default:
        this.$alertify.error("Unauthorised user, Please contact your system admin");
        break
    }
  },

  methods: {
    Choosetype() {
			this.show = true;
			this.download = false;
			this.getRejectReasonReportDataForXls(3)
		},
    startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
    closeaddmodalShow() {
          this.addmodalShow = false
        },

    closeRejectReasonmodal() {
          this.addRejectReasonmodal = false;
          this.rejectreason = '';
          document.getElementById("rejectreason").value = "";
          this.addWarehouseid = '';
          this.addclientid = '';
          this.listWarehouseAddReason = [];
          this.getWarehouseList();

        },

      addmodal(rejectrreasonid) {
          this.Statusaction = "add"
          this.addmodalShow = true
          this.rejectID = rejectrreasonid;
        },
      closedetailRejectReasonmodal() {
          this.detailRejectReasonmodal = false;
        },

      //open new pop up for saving the rto
      addNewRejectReasons() {
        this.addRejectReasonmodal = true,
			  this.Reasonaction = 'add',
				this.$validator.reset();
			  this.errors.clear();
		},

    //to close add (new) form
		closeNewRejectReason() {
			this.addRejectReasonmodal = false
		},

    onPageChange(page) {
      this.currentPage = page;
      this.getRejectReasonReport(2)

    },

        //Call page number from pagination
    getPaginationData(currentPage) {
        this.pageno = (currentPage - 1) * this.pageLimit;
        this.getRejectReasonReport();
      },

    getOrderSearch() {
        this.currentPage = 1;
        this.getRejectReasonReport();
      },

    //   getWarehouseList() {
    //       this.pageno = 0;
    //       if (window.localStorage.getItem("warehouseList") !== null) {
    //         var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
    //         var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
    //         var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
    //         this.listWarehouseData = JSON.parse(plaintextwarehouse);
    //         if (this.listWarehouseAddReason.length == 0) {
    //           this.listWarehouseAddReason = this.listWarehouseData;
    //         }

    //       } else {
    //       var userToken = window.localStorage.getItem('userToken')
    //       var myStr = userToken.replace(/"/g, '');
    //       this.input = ({
    //         clientid: this.clientid,
    //       });

    //       axios({
    //           method: 'POST',
    //           'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
    //           'data': this.input,
    //           headers: {
    //             'Authorization': 'Bearer ' + myStr
    //           }
    //         })
    //         .then(result => {
    //           this.listWarehouseData = result.data.data;
    //           if (this.listWarehouseAddReason.length == 0) {
    //             this.listWarehouseAddReason = result.data.data;
    //           }
    //         }, error => {
    //           console.error(error)
    //         })
    //       }
    //     },

    //   getClientList() {
		// 	this.resultCount = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listclientData = JSON.parse(plaintextclient);
		// 	} else {
		// 	var userToken = window.localStorage.getItem('userToken')
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.input = ({
		// 		warehouseid: this.warehouseid,
		// 	});
		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 		.then(result => {
		// 			this.listclientData = result.data.data;
		// 		}, error => {
		// 			console.error(error)
		// 		})
		// 	}
		// },

    // clientSelected() {
		// 	if (this.clientid != this.client) {
    //     this.clientid = this.client;
    //     this.warehouse=''
    //     this.getWarehouseList();
		// 		if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 			this.warehouse = this.warehouseid = '';
		// 		}
		// 	}
		// 	if (this.clientid) {
		// 		if (this.warehouseid == '') {
		// 			this.getWarehouseList();
		// 		}
		// 	}
		// 	this.resultCount = 0
		// 	this.totalRows=0
		// 	this.listRejectReasonData = []
		// 	this.totalPage = 0
		// },

    getWarehouseListAddReason() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;

			this.input = ({
				clientid: this.addclientid,
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listWarehouseAddReason = result.data.data;
				}, error => {
					console.error(error)
				})
		},
    clientSelectedAdd() {
			this.getWarehouseListAddReason();
		},
    // warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	if (this.warehouseid) {
		// 		if (this.clientid == '') {
		// 			this.getClientList();
		// 		}
		// 	}
		// 	this.resultCount = 0
		// 	this.totalRows=0
		// 	this.listRejectReasonData = []
		// 	this.totalPage = 0
		// },

    dateFormat1(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DD') + " 00:00:00";
    },
    dateFormat2(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DD') + " 23:59:59";
    },



    	// deletes target record
		removeRow: function(rejectID) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.rejectreasonid = rejectID;
			console.log(this.rejectreasonid + "====rej==");
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'deleteSingleRejectReason',
					'data': {
						"rejectreasonmasterid": this.rejectreasonid,
						"warehouseid": localStorage.getItem("selectedWarehouse"),
						"clientid": this.client
					},
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.listRejectReasonData.splice(this.rejectreasonid, 1);
          this.$alertify.success(this.$t('rejectreason.table.reasonDeleted'))
          this.addmodalShow = false
          this.getRejectReasonReport()
				});
		},

    generateNewReason() {
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');
      if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
      if (this.rejectreason == '' || (localStorage.getItem("selectedWarehouse") == "" && this.client == "")) {
        this.$alertify.error(this.$t('rejectreason.table.enterAllValues'));
        return false;
      } else {
        if (this.user_type == 'client_user') {
          this.input = {
            'reason': this.rejectreason.trim(),
            'createdby': this.loginUserEmail,
            'warehouseid': localStorage.getItem("selectedWarehouse"),
            'clientid': this.client
          }
        } else if (this.user_type == 'warehouse_user') {
          this.input = {
            'reason': this.rejectreason.trim(),
            'createdby': this.loginUserEmail,
            'warehouseid': localStorage.getItem("selectedWarehouse"),
            'clientid': this.client
          }
        } else {
          this.input = {
            'reason': this.rejectreason.trim(),
            'createdby': this.loginUserEmail,
            'warehouseid': localStorage.getItem("selectedWarehouse"),
            'clientid': this.client,
          }
        }

        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'AddNewRejectReason',
            'data': this.input,
            headers: {
              'Authorization': myStr
            }
          })
          .then((response) => {
            if (response.data.errorCode == 0) {
              this.$alertify.success(this.$t('rejectreason.table.reasonAdded'))
              this.addRejectReasonmodal = false;
              this.rejectreason = '';
              document.getElementById("rejectreason").value = '';
              this.addWarehouseid = '';
              this.addclientid = '';
              this.rejectreason = '';
              this.getRejectReasonReport();
            } else {
              this.$validator.reset();
              this.rejectreason = '';
              this.addWarehouseid = '';
              this.addclientid = '';
              this.$alertify.error(response.data.msg)

            }
          })
          .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
          })
      }
    },

    getRejectReasonReport(check) {
      if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
      if (this.client == "" || localStorage.getItem("selectedWarehouse") == "") {
				if (this.client == "") {
					this.ClientErr = this.$t('common.clientError');
				} else if (localStorage.getItem("selectedWarehouse") == "") {
					this.WarehouseErr = this.$t('common.warehouseError')
				}
				return false;
			}else {
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				this.resultCount = 0;
				this.isLoading = true;
				this.input = ({
					offset:(this.currentPage - 1) * 10,
					limit: 10,
					warehouseid: localStorage.getItem("selectedWarehouse"),
					clientid: this.client
				})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getRejectReasonMasterList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
          this.listRejectReasonData = result.data.rows
          this.totalrows = result.data.count
          this.resultCount = result.data.count
          if (this.totalRows == 0) {
            this.totalPage = 0
          } else if (this.totalRows < 10) {
            this.totalPage = 1
          } else {
            this.totalPage = Math.ceil(this.totalRows / 10)
          }
          this.isLoading = false;

        }, error => {
          console.error(error)
        })
    }
  }
,
    // //Sets total number of pages
		// setPageCounts(total_rows) {
		// 	if (total_rows > 0) {
		// 		if (total_rows <= this.pageLimit) {
		// 			this.totalPage = 1;
		// 		} else {
		// 			this.totalPage = Math.ceil(total_rows / this.pageLimit);
		// 		}
		// 	} else {
		// 		this.totalPage = 0;
		// 	}
		// },

    resetSearchForm() {
			this.rejectreasonid = '';
			this.status = '';
			this.rejectreason = '';
			this.getRejectReasonReport();
		},
  	resetSearchForm() {
      this.warehouse = '';
      this.download = true;
			this.isLoading = false;
			this.ClientErr = ''
			this.WarehouseErr = ''
			this.rejectreasonid = '';
			this.status = '';
			this.rejectreason = '';
			this.resultCount = 0
			this.listRejectReasonData = []
			this.totalRows=0;
      this.totalrows=0;
			this.totalPage = 0
			if (this.user_type == 'warehouse_user') {
				// this.client = '';
				// this.clientid = ''
			} else if (this.user_type == 'client_user') {
				// this.warehouse = '';
				// this.warehouseid = ''
			} else {
				// this.client = '';
				// this.clientid = ''
				// this.warehouse = '';
				// this.warehouseid
			}
		},


    dateFormat(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DD');
    },

    //validate all form fields on onsubmit()
    onSubmit: function() {
			this.$validator.validateAll().then(() => {}).catch(() => {
				console.log('errors exist')
			});
		},
  }
}


// WEBPACK FOOTER //
// ./src/views/components/rejectreason/rejectreason.component.js